import React, { useEffect, useRef, useState } from 'react';
import { ChevronDown, MoreVertical } from 'lucide-react';

// Generic "Actions ▾" dropdown. items: [{ label, icon: Icon, onClick, danger, testId, disabled }] — null entries are skipped.
export default function PhotoActionsMenu({ items, label = 'Actions', compact = false, testId = 'photo-actions', align = 'right', up = false, buttonStyle }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  useEffect(() => {
    if (!open) return undefined;
    const h = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    const k = (e) => { if (e.key === 'Escape') setOpen(false); };
    window.addEventListener('mousedown', h); window.addEventListener('keydown', k);
    return () => { window.removeEventListener('mousedown', h); window.removeEventListener('keydown', k); };
  }, [open]);
  const list = (items || []).filter(Boolean);
  return (
    <div className="relative inline-block" ref={ref} onClick={(e) => e.stopPropagation()} onDoubleClick={(e) => e.stopPropagation()}>
      {compact ? (
        <button type="button" onClick={() => setOpen((o) => !o)} data-testid={`${testId}-btn`} title={label} aria-haspopup="menu" aria-expanded={open}
          className="p-1 rounded-full bg-black/55 text-white hover:bg-black/70" style={buttonStyle}><MoreVertical size={14} /></button>
      ) : (
        <button type="button" onClick={() => setOpen((o) => !o)} data-testid={`${testId}-btn`} aria-haspopup="menu" aria-expanded={open}
          className="inline-flex items-center gap-1 px-3 py-1.5 rounded text-xs font-title border" style={{ borderColor: 'var(--navy)', color: 'var(--navy)', background: 'white', ...buttonStyle }}>
          {label} <ChevronDown size={13} />
        </button>
      )}
      {open && (
        <div role="menu" data-testid={`${testId}-menu`} className={`absolute z-[120] min-w-[12rem] bg-white rounded-lg shadow-xl border py-1 text-sm ${align === 'right' ? 'right-0' : 'left-0'} ${up ? 'bottom-full mb-1' : 'mt-1'}`} style={{ borderColor: 'rgba(0,0,0,0.12)' }}>
          {list.map((it) => (
            <button key={it.label} type="button" role="menuitem" disabled={it.disabled} data-testid={it.testId}
              onClick={() => { setOpen(false); it.onClick(); }}
              className="flex items-center gap-2 w-full px-3 py-1.5 hover:bg-black/5 text-left disabled:opacity-40"
              style={{ color: it.danger ? '#8a1f11' : 'var(--ink)' }}>
              {it.icon ? <it.icon size={14} /> : null} {it.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
